export default __webpack_public_path__ + "static/media/portfolio2.2f8cc124.png";